export const CLIENTS = [
  { name: 'Ezpada', logo: '/client-logos/ezpada.png' },
  { name: 'Amius', logo: '/client-logos/amius.png' },
  { name: 'Eminent Energy', logo: '/client-logos/eminent-energy.png' },
  { name: 'Sunrise Brokers', logo: '/client-logos/sunrise-brokers.png' },
];
